{
  "button_text": "Filter",
  "title": "Filter",
  "categories": "Categories",
  "who": "Who",
  "labels": "Labels",
  "sources": "Sources",
  "empty_who": "No who labels have been created yet!",
  "empty_labels": "No labels have been created yet!",
  "empty_sources": "No sources have been connected yet!",
  "add_source_cta": "Add a source",
  "clear_button_aria": "Clear filters"
}
